import React from "react";
import { ExerciseTypeContainer } from "./ExerciseTypeContainer";
import { VideoPlayer } from "@/components/shared/VideoPlayer";

// Interface específica para dados deste tipo de exercício
interface WatchLargeVideoData {
  videoUrl?: string;
  duration?: string;
}

// Interface de props atualizada
type WatchLargeVideoProps = {
  item: {
    id: string;
    title: string;
    name?: string;
    description?: string;
    type: string;
    order: number;
    moduleId?: string;
    content?: unknown;
  };
};

export const WatchLargeVideo: React.FC<WatchLargeVideoProps> = ({ item }) => {
  // Extrai e processa os dados específicos deste tipo de exercício
  const extractExerciseData = (): WatchLargeVideoData => {
    try {
      // Parse content if it's a string, or use it directly if it's already an object
      const rawData = typeof item.content === 'string' ? JSON.parse(item.content) : item.content;
      
      return {
        videoUrl: rawData?.videoUrl || "",
        duration: rawData?.duration || "0min 0seg"
      };
    } catch (error) {
      console.error("Error parsing exercise data:", error);
      // Return default values if parsing fails
      return {
        videoUrl: "",
        duration: "0min 0seg"
      };
    }
  };
  
  // Obtém os dados tipados para este exercício
  const exerciseData = extractExerciseData();

  return (
    <ExerciseTypeContainer
      item={item as never}
      title1={item.name || "Assista ao vídeo"}
      title2={item.title || "Vocabulário Simples / parte 1"}
      subtitle={exerciseData.duration || "4min 32seg"}
      exerciseNumber={`${item.id}`}
      hideVerifyButton={true}
    >
      <VideoPlayer src={exerciseData.videoUrl} />
    </ExerciseTypeContainer>
  );
};
